module.exports = __webpack_public_path__ + "img/Bitlayer.efd8edb5.png";